import React from 'react';
import Selector from '../../../components/hours/selector';
import { useSelectedStudents } from '../hooks/use-selected-students';
import { useStudents } from '../hooks/use-students';

const usePreferredHourSelector = ({ student }) => {
    const {
        getStudentPreferredHour,
        setStudentPreferredHour
    } = useStudents();
    const { isStudentSelected } = useSelectedStudents();
    const value = getStudentPreferredHour(student) || '';
    const onChange = (hourId) => setStudentPreferredHour(student, hourId);
    const disabled = !isStudentSelected(student);
    return {
        value,
        onChange,
        disabled
    };
};

export const HourSelector = ({ student }) => {
    const { 
        value,
        onChange,
        disabled
    } = usePreferredHourSelector({ student });
    return (
        <Selector
            size='sm'
            placeholder='Any Hour'
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
    );
};
